export const parseNumber = (numberStr: string): number | null => {
  try {
    const num = parseFloat(numberStr);
    return isNaN(num) ? null : num;
  } catch (err) {
    return null;
  }
};

export const parseNumberOrError = (numberStr: string): number => {
  const result = parseNumber(numberStr);
  if (result === null) {
    throw new Error(`could not parse into number : ${numberStr}`);
  }
  return result;
};
